import React, { useState } from 'react';
import * as ui from '@digital/ui';
import { CrfTipoAgrupador, TPData } from '@app/api/crf/acronimo/Agrupador/tipoAgrupador';
import { Icon, Collapse } from 'antd';
import { hasPermission } from '@app/helpers/permissions';

interface TipoAgrupadorProps {
  titulo: string;
  label: string;
  data: CrfTipoAgrupador[];
  handleDelete(id: string): Promise<unknown>;
  handleCreate: (record: Omit<TPData, 'codigo'>) => Promise<CrfTipoAgrupador | undefined>;
  handleUpdate: (record: { id: string; nome: string }) => Promise<boolean>;
  shouldUpdate: (needed: boolean) => void;
  isUpdate: boolean;
}

const CRFTipoAgrupador = (props: TipoAgrupadorProps) => {
  const { titulo, label, data, isUpdate, handleCreate, handleUpdate, handleDelete, shouldUpdate } = props;
  const [nome, setNome] = useState<string>('');

  const customColumns = () => {
    return [
      {
        title: 'Codigo',
        dataIndex: 'data.codigo',
        width: '10%',
      },
      {
        title: 'Nome',
        dataIndex: 'data.nome',
        width: '80%',
        renderEdit: () => <ui.FormInput name="data.nome" disabled={false} required />,
      },
      {
        title: 'Opções',
        render: (item: CrfTipoAgrupador) =>
          hasPermission(['ACRONIMOS_DELETAR']) && (
            <>
              <ui.Button
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                onClick={() => {
                  handleDelete(item.id)
                    .then(() => {
                      !isUpdate ? shouldUpdate(true) : shouldUpdate(false)
                    });
                }}
                icon="science-minus"
              />
            </>
          ),
      },
    ] as ui.InlineEditColumnProps<CrfTipoAgrupador>[];
  };

  const handleChangeNome = (value: string) => (value.length > 0 ? setNome(value) : setNome(''));

  const handleClick = async () => {
    if (nome) {
      const result = await handleCreate({ nome });
      if (result) {
        !isUpdate ? shouldUpdate(true) : shouldUpdate(false);
      }
    }
  };

  const { Panel } = Collapse;

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="1" header={titulo} style={{ border: 0 }}>
          <ui.MasterDetailForm>
            <ui.Widget
              actions={[
                hasPermission(['ACRONIMOS_SALVAR', 'ACRONIMOS_EDITAR']) && (
                  <ui.Button icon="commons-ok" name="" title="Salvar" onClick={handleClick} />
                ),
              ]}>
              <ui.Row>
                <ui.InlineEditTable
                  rowKey="id"
                  columns={customColumns()}
                  updateItem={hasPermission(['ACRONIMOS_EDITAR']) ? handleUpdate : undefined}
                  dataSource={data}
                  pagination={false}
                  disablenotification={false}
                />
              </ui.Row>
              <ui.Row>
                <fieldset>
                  <legend>Inserir Nova Linha</legend>
                  <ui.FormInput
                    name="nome"
                    label="Nome"
                    placeholder={label}
                    title="Nome"
                    onChange={e => (hasPermission(['ACRONIMOS_EDITAR']) ? handleChangeNome(e.target.value) : undefined)}
                    span={3}
                  />
                </fieldset>
              </ui.Row>
            </ui.Widget>
          </ui.MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default CRFTipoAgrupador;
